import React, { FC, ChangeEvent, useEffect, useState, useRef } from 'react';
import { windowService, documentService } from '../../../../../../utils/window.utils';
import { TGDPRConsentField } from '../../../../types/gdprConsentField.types';
import GDPRPopupModal from './modal';
import { ButtonClassNames } from '../../../../types/button.types';

const GdprConsentFieldPopup: FC<TGDPRConsentField> = (props) => {
  const { field, errors } = props;
  const initialValue = '{isFormOverlay: false}';
  const hasAnyError = !!props.errors?.length;
  const id = field.valueField.id;
  const inputRef = useRef<HTMLInputElement | null>(null);
  const name = field.valueField.name;
  const [showPopup, setShowPopup] = useState(false);
  const [value, setValue] = useState(initialValue);
  const [submitCounter, setSubmitCounter] = useState(0);

  const encodeValue = (rawValue: string): string => windowService()?.btoa(rawValue);

  useEffect(() => {
    if (!props?.value) {
      props.onChange(field.valueField.name, initialValue, props.isValid, []);
    } else {
      props.onChange(field.valueField.name, encodeValue(props.value), props.isValid, []);
    }
  }, []);

  useEffect(() => {
    const otherValidationErrors = documentService()?.querySelectorAll?.('.sitecore-jss-form__error-list')?.length > 0;
    setShowPopup(!otherValidationErrors && !!errors?.length);
  }, [errors, setShowPopup]);

  useEffect(() => {
    if (value === initialValue) return;
    const formtag = inputRef.current?.closest('form');
    (formtag?.querySelector(`.${ButtonClassNames['Submit']}`) as HTMLButtonElement)?.click?.();
  }, [value, submitCounter]);

  const onChange = (e: ChangeEvent<HTMLInputElement>): void => {
    props.onChange(field.valueField.name, e?.target?.value, props.isValid, []);
  };

  const handlePopupSubmit = (data: string): void => {
    props.onChange(field.valueField.name, encodeValue(data), props.isValid, []);
    setShowPopup(false);
    setValue(data);
    setSubmitCounter((value) => value + 1);
  };

  return (
    <div
      className={`
        ${hasAnyError ? 'sitecore-jss-form__control--has-error' : ''}
        `}
    >
      <input
        id={id}
        name={name}
        className="sitecore-jss-form__field sitecore-jss-form__field--gdpr"
        ref={inputRef}
        type="hidden"
        onChange={onChange}
        value={value}
        form="novalidatedform"
      />
      {errors?.length > 0 && showPopup && field.model.gdprPolicies && (
        <GDPRPopupModal
          handlePopupSubmit={handlePopupSubmit}
          gdprPolicies={field.model.gdprPolicies}
          hidePopup={() => setShowPopup(false)}
        />
      )}
    </div>
  );
};

export default GdprConsentFieldPopup;
